// extracted by mini-css-extract-plugin
export default {"main":"CocktailReviews_main__0FeIc","reviews":"CocktailReviews_reviews__C7ouD"};